// extracted by mini-css-extract-plugin
module.exports = {"reply_message":"replyMessage_reply_message__1feWS","reply_message__support":"replyMessage_reply_message__support__1JuDr"};